export const checkModifiedParams = (newTimestamp, currentLastModifiedAt) => {
  const appModifiedAt = new Date(newTimestamp ?? 0).valueOf();
  const needUpdateLastModifiedAt = appModifiedAt > currentLastModifiedAt;

  return { appModifiedAt, needUpdateLastModifiedAt };
};
